@if (enabled) {
  <button
    mat-button
    [matTooltip]="tooltipActiveProfile"
    [matMenuTriggerFor]="clientPicker"
    [disabled]="!accountClients || accountClients.length == 0">
    <mat-icon>supervisor_account</mat-icon>
    <div>{{accountClient?.client?.name || textNoClient}}</div>
  </button>
}
<mat-menu
  #clientPicker="matMenu"
  xPosition="before">
  @for (accountClient of accountClients; track accountClient.client.id) {
    <button
      mat-menu-item
      [textContent]="accountClient.client.name"
      (click)="onClientChanged(accountClient)">
    </button>
  }
</mat-menu>
